var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemixLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16799_96520)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16799_96520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: -3,
    width: 68,
    height: 69
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8056 -2.2832H-8.71194V65.2344H58.8056V-2.2832Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16799_96520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37004 2.56378C1.37004 1.14783 2.51787 0 3.93382 0H31.6771C40.1081 0 46.9431 6.83486 46.9431 15.2661C46.9431 23.6975 40.1081 30.5321 31.6771 30.5321H25.6321C10.9114 30.5321 1.37004 20.9909 1.37004 9.22109V2.56378Z",
    fill: "url(#paint0_linear_16799_96520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3078 53.1291C49.4757 55.9519 47.4316 60.0001 43.8384 60.0001H23.0494C21.7519 60.0001 20.5221 59.4296 19.6955 58.4442L0.996471 36.3567C0.358451 35.5961 0.0064713 34.6417 0 33.655L0.000102973 4.32196C-0.0269786 0.198532 5.29458 -1.5798 7.82002 1.70875L47.3078 53.1291Z",
    fill: "url(#paint1_linear_16799_96520)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16799_96520",
    x1: 44.8557,
    y1: 4.54297,
    x2: 14.436,
    y2: 15.5819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99FC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#897ED4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16799_96520",
    x1: 17.6897,
    y1: 15.0191,
    x2: -4.59802,
    y2: 45.5947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.940808,
    stopColor: "#FBA0C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16799_96520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.1967,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemixLarge);
export default __webpack_public_path__ + "static/media/remixLarge.00297e19d5228c191db98694e758e276.svg";
export { ForwardRef as ReactComponent };